<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="baseUrl$ | async as baseUrl" class="relate-to-parent row">
    <div class="col-3 p-0">
        <winde-customer-accordion [badgeAttribute]="customersBadgeAttribute" [baseUrl]="baseUrl"></winde-customer-accordion>
    </div>

    <div class="col-9 p-0">
        <div class="customers-main-box">
            @if (selectedCustomer$ | async) {
                <div class="customers-header">
                    <winde-customer-details [baseUrl]="baseUrl"></winde-customer-details>
                </div>
                <winde-users-grid></winde-users-grid>
            } @else {
                <div windeGridEmpty>
                    <strong>{{
                            'customer.home.' + ((customerFilter$ | async) ? 'matchesNotFound' : 'customersNotFound') | translate
                        }}</strong>
                </div>
            }
        </div>
    </div>
</div>
